'use strict';

/**
 * Subscribe to an event
 *
 * @param eventName
 * @param listener
 */
function subscribe(eventName, listener) {
  document.addEventListener(eventName, listener);
}

/**
 * Unsubscribe from an event
 *
 * @param eventName
 * @param listener
 */
function unsubscribe(eventName, listener) {
  document.removeEventListener(eventName, listener);
}

/**
 * Publish (raise) the event
 *
 * @param eventName
 * @param data
 */
function publish(eventName, data) {
  const event = new CustomEvent(eventName, {detail: data});
  document.dispatchEvent(event);
}

export { publish, subscribe, unsubscribe };
